<template>
  <div class="overflow-hidden">
    <BaseContainer>
      <div
        class="flex flex-col md:flex-row md:items-center gap-4 justify-between mb-8"
      >
        <!-- Don't hide the title. it holds it's button siblings in place. -->
        <h2 class="h3 overflow-x-hidden">
          {{ title }}
        </h2>

        <div class="flex gap-2 md:gap-6">
          <div class="flex gap-2" v-if="showNavigation">
            <button
              @click="prevSlide"
              type="button"
              :title="$t('common.next')"
              class="cursor-pointer w-11 aspect-square flex items-center justify-center rounded-full bg-surface-light border border-surface-grey hover:bg-surface-grey transition"
            >
              <ArrowRightIcon class="rotate-180" />
            </button>

            <button
              type="button"
              @click="nextSlide"
              :title="$t('common.prev')"
              class="cursor-pointer w-11 aspect-square flex items-center justify-center rounded-full bg-surface-light border border-surface-grey hover:bg-surface-grey transition"
            >
              <ArrowRightIcon />
            </button>
          </div>

          <BaseButton color="default" size="sm" v-if="link" :to="link">
            {{ linkText ? $t(linkText) : $t('common.see_all') }}
          </BaseButton>
        </div>
      </div>
      <swiper-container
        class="swiper-overflow-visible swiper-overflow-hidden-desktop"
        :slides-per-view="1.2"
        :space-between="24"
        :loop="true"
        ref="swiperRef"
        :breakpoints="{
          768: {
            slidesPerView: 3,
          },
        }"
      >
        <slot />
      </swiper-container>
    </BaseContainer>
  </div>
</template>

<script setup lang="ts">
  import type { SwiperContainer } from 'swiper/element';
  import { ref } from 'vue';

  import ArrowRightIcon from '../icons/ArrowRightIcon.vue';
  import BaseButton from './BaseButton.vue';
  import BaseContainer from './BaseContainer.vue';

  const { title, link, linkText, showNavigation } = defineProps<{
    showNavigation?: boolean;
    title?: string;
    link?: string;
    linkText?: string;
  }>();

  const swiperRef = ref<SwiperContainer | null>(null);

  function nextSlide() {
    if (swiperRef.value) {
      swiperRef.value.swiper.slideNext();
    }
  }

  function prevSlide() {
    if (swiperRef.value) {
      swiperRef.value.swiper.slidePrev();
    }
  }
</script>
